import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/dictionary",
    name: "dictionary",
    component: dashboard,
    redirect: {
      name: "productTypeIndex"
    },
    children: [
      {
        path: "productTypeIndex",
        name: "productTypeIndex",
        meta: { title: "区域分类管理" },
        component: () => import("@/views/productType/baseDataProductType.vue"),
        children: [
          {
            path: "editProductTypeInfo/:productTypeId",
            name: "editProductTypeInfo",
            meta: { title: "编辑区域分类" },
            component: () => import("@/views/productType/productTypeManage.vue")
          },
          {
            path: "addProductTypeInfo",
            name: "addProductTypeInfo",
            meta: { title: "添加区域分类" },
            component: () => import("@/views/productType/addProductType.vue")
          }
        ]
      }
    ]
  },
  {
    path: "/salesPerson",
    name: "salesPerson",
    component: dashboard,
    redirect: {
      name: "salesPersonIndex"
    },
    children: [
      {
        path: "salesPersonIndex",
        name: "salesPersonIndex",
        meta: { title: "售后人员管理" },
        component: () => import("@/views/salePerson/salePerson.vue")
      }
    ]
  }
];
